<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-input @keyup.enter.native="handleFilter" size="small" style="width: 200px;" class="filter-item"
          :placeholder="'名称'" v-model="listQuery.key"> </el-input>
        <el-button class="filter-item" size="small" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>
        <permission-btn size="small" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white" style="height: 100%;">
        <auth-table style="height:calc(100% - 60px)" ref="mainTable" :select-type="'checkbox'"
          :table-fields="headerList" :data="list" v-loading="listLoading" @row-dblclick="onBtnClicked('btnEdit')"
          @row-click="rowClick" @selection-change="handleSelectionChange" :enable-sorting="true"
          :enable-custom-filter="true" @sort-change="handleSortChange" @filter-change="handleFilterChange"></auth-table>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
          @pagination="handleCurrentChange" />
      </div>
      <el-dialog v-el-drag-dialog class="dialog-mini" width="900px" :title="textMap[dialogStatus]"
        :visible.sync="dialogFormVisible" @close="resetTemp">
        <el-row :gutter="10">
          <el-form ref="dataForm" :model="temp" :rules="rules" size="medium" label-width="80px" label-position="left">
            <el-col :span="8">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="盘点单号" prop="inventoryCode">
                    <el-input v-model="temp.inventoryCode" readonly placeholder="" :style="{ width: '100%' }">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="盘点标题" prop="inventoryTitle">
                    <el-input v-model="temp.inventoryTitle" placeholder="请输入盘点标题" :style="{ width: '100%' }">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="盘点仓库" prop="storeName">
                    <el-select v-model="temp.storeName" placeholder="请选择盘点仓库" :style="{ width: '100%' }">
                      <el-option v-for="(item, index) in Storetions" :key="index" :label="item.storeName"
                        :value="item.storeName">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="盘点部门" prop="useDepartment">
                    <el-select v-model="temp.useDepartment" placeholder="请选择盘点部门" :style="{ width: '100%' }">
                      <el-option v-for="(item, index) in Deptions" :key="index" :label="item.useDepartment"
                        :value="item.useDepartment">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="创建人" prop="creator">
                    <el-input v-model="temp.creator" placeholder="请输入创建人" readonly :style="{ width: '100%' }">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="盘点日期" prop="createDate">
                    <el-date-picker v-model="temp.createDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                      :style="{ width: '100%' }" placeholder="请选择盘点日期" clearable></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-row>
                <el-divider content-position="left">盘点明细</el-divider>

                <el-table :data="tableData" ref="multipleTable" height="300" border>
                  <el-table-column prop="assetCode" label="资产编号"></el-table-column>
                  <el-table-column prop="assetName" label="资产名称">
                  </el-table-column>
                  <el-table-column prop="specification" label="规格">
                  </el-table-column>
                  <el-table-column prop="serialNumber" label="SN号">
                  </el-table-column>
                  <el-table-column prop="useDepartment" label="部门">
                  </el-table-column>
                  <el-table-column prop="bookQuantity" label="账面数量">
                  </el-table-column>
                  <el-table-column prop="actualQuantity" label="实际数量">
                  </el-table-column>
                  <el-table-column prop="inventoryPerson" label="盘点人">
                  </el-table-column>

                </el-table>
              </el-row>
            </el-col>
          </el-form>
        </el-row>

        <div slot="footer">
          <el-button size="small" type="primary" @click="exportData">导出数据</el-button>
          <el-button size="small" @click="dialogFormVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import * as inventoryPlans from '@/api/inventory/inventoryPlans'
import waves from '@/directive/waves' // 水波纹指令
import Sticky from '@/components/Sticky'
import permissionBtn from '@/components/PermissionBtn'
import Pagination from '@/components/Pagination'
import elDragDialog from '@/directive/el-dragDialog'
import { defaultVal } from '@/utils/index'
import extend from '@/extensions/common.js'
import AuthTable from '../../../components/Base/AuthTable.vue'
import ColumnDefine from '@/interface/columnDefine'
import * as XLSX from 'xlsx';
export default {
  name: 'inventoryPlan',
  components: { Sticky, permissionBtn, Pagination, AuthTable, },
  directives: {
    waves,
    elDragDialog,
  },
  mixins: [extend],
  data() {
    return {
      headerList: [], // 主列表列定义
      multipleSelection: [], // 列表checkbox选中的值
      tableKey: 0,
      list: null,
      filteredList: null, // 过滤后的列表数据
      total: 0,
      listLoading: true,
      tableData: [],
      userId: '',
      listQuery: {
        // 查询条件
        page: 1,
        limit: 20,
        key: undefined,
        State: '已完成'
      },
      Storetions: [], Deptions: [],
      userptions: [],//盘点人
      temp: {
        inventoryCode: undefined,
        inventoryTitle: undefined,
        storeName: undefined,
        useDepartment: undefined,
        creator: undefined,
        createDate: null,
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加',
      },
      selectedRows: [],
      rules: {
        inventoryTitle: [{
          required: true,
          message: '请输入盘点标题',
          trigger: 'blur'
        }],
        storeName: [],
        useDepartment: [],
        creator: [],
        previousStoreName: '',
        previousDepartment: '',
        createDate: [{
          required: true,
          message: '请选择盘点日期',
          trigger: 'change'
        }],
      },
    }
  },
  created() {
    this.headerList = [
      new ColumnDefine('inventoryCode', '盘点单号', true, true, '', '', 'string', 'varchar', 'InventoryCode', '120px'),
      new ColumnDefine('inventoryTitle', '盘点标题', true, true, '', '', 'string', 'varchar', 'InventoryTitle', '120px'),
      new ColumnDefine('storeName', '盘点仓库', true, true, '', '', 'string', 'varchar', 'StoreName', '120px'),
      new ColumnDefine('useDepartment', '盘点部门', true, true, '', '', 'string', 'varchar', 'UseDepartment', '120px'),
      new ColumnDefine('creator', '创建人', true, true, '', '', 'string', 'varchar', 'Creator', '100px'),
      new ColumnDefine('createDate', '盘点日期', true, true, '', '', 'DateTime', 'datetime', 'CreateDate', '120px'),
      new ColumnDefine('state', '状态', true, true, '', '', 'string', 'varchar', 'State', '100px'),
    ]
    this.getList()
    this.GetStoretions()
    this.GetDeptions()
    this.GetInventoryPerson()
  },
  methods: {
    exportData() {
      const headers = {
        '资产编号': 'assetCode',
        '资产名称': 'assetName',
        '规格': 'specification',
        'SN号': 'serialNumber',
        '部门': 'useDepartment',
        '账面数量': 'bookQuantity',
        '实际数量': 'actualQuantity',
        '盘点人': 'inventoryPerson',
        '差异': 'difference'  // 新增差异列
      };
      // 处理数据，添加自定义差异列
      const exportData = this.tableData.map(item => {
        return {
          '资产编号': item.assetCode,
          '资产名称': item.assetName,
          '规格': item.specification,
          'SN号': item.serialNumber,
          '部门': item.useDepartment,
          '账面数量': item.bookQuantity,
          '实际数量': item.actualQuantity,
          '盘点人': item.inventoryPerson,
          // 按要求计算差异：actualQuantity为1时差异为0，为0时差异为1
          '差异': item.actualQuantity === 1 ? 0 : 1
        };
      });
      // 创建工作簿和工作表
      const ws = XLSX.utils.json_to_sheet(exportData, {
        header: Object.keys(headers), // 确保按照定义的顺序排列
        skipHeader: false
      });

      // 创建工作簿
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '资产盘点清单');

      // 导出Excel文件
      XLSX.writeFile(wb, `资产盘点清单_${new Date().toLocaleDateString()}.xlsx`);
    },

    //获取盘点人
    async GetInventoryPerson() {
      try {
        let result = await inventoryPlans.GetInventoryPerson()
        this.userptions = result.result
      } catch (error) {
        console.error('获取盘点人失败', error)
      }
    },

    GetStoretions() {
      inventoryPlans.GetStoretions().then((response) => {
        this.Storetions = response.result
      })
    },
    GetDeptions() {
      inventoryPlans.GetDeptions().then((response) => {
        this.Deptions = response.result
      })
    },
    SelectionChange(val) {
      this.selectedRows = val;
    },
    rowClick(row) {
      this.$refs.mainTable.clearSelection()
      this.$refs.mainTable.toggleRowSelection(row)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    onBtnClicked: function (domId, callback) {
      console.log('you click:' + domId)
      switch (domId) {

        case 'btnAdd':
          this.handleCreate()
          break
        case 'btnEdit':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '只能选中一个进行编辑',
              type: 'error',
            })
            return
          }
          this.handleUpdate(this.multipleSelection[0])
          break
        case 'btnDel':
          if (this.multipleSelection.length < 1) {
            this.$message({
              message: '至少删除一个',
              type: 'error',
            })
            return
          }
          this.handleDelete(this.multipleSelection)
          break
        case 'btnExport':
          this.$refs.mainTable.exportExcel('资源文件', callback)
          break
        default:
          break
      }
    },
    getList() {
      this.listLoading = true
      inventoryPlans.getList(this.listQuery).then((response) => {
        this.list = response.data
        this.total = response.count
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page
      this.listQuery.limit = val.limit
      this.getList()
    },
    handleModifyStatus(row, disable) {
      // 模拟修改状态
      this.$message({
        message: '操作成功',
        type: 'success',
      })
      row.disable = disable
    },
    resetTemp() {
      let obj = {};
      this.previousStoreName = '';
      this.previousDepartment = '';
      this.tableData = [];
      this.headerList.forEach((item) => {
        obj[item.columnName] = defaultVal(item.entityType)
      })
      this.temp = Object.assign({}, obj) // copy obj
    },
    handleCreate() {
      // 弹出添加框
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      // 保存提交
      this.$refs['dataForm'].validate((val) => {
        if (!val) return;
        if (this.tableData.length <= 0) {
          this.$alert('明细不能为空', '系统消息', {
            confirmButtonText: '确定',
          });
          return
        }
        var json = {
          main: this.temp,
          tabledata: this.tableData
        }

        inventoryPlans.add(JSON.stringify(json)).then(() => {
          this.list.unshift(this.temp)
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '创建成功',
            type: 'success',
            duration: 2000,
          })
        })
      })
    },
    handleUpdate(row) {
      // 弹出编辑框
      inventoryPlans.get(row.id).then((response) => {
        this.temp = response.result
        this.previousStoreName = response.result.storeName
        this.previousDepartment = response.result.useDepartment
        return inventoryPlans.GetInventoryDetail(response.result.inventoryCode);
      }).then((response) => {
        this.tableData = response.result
      }).catch((error) => {
        console.error('获取数据失败', error)
      });


      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      // 更新提交
      this.$refs['dataForm'].validate(() => {
        var tempData = {
          main: this.temp,
          tabledata: this.tableData
        }
        inventoryPlans.update(JSON.stringify(tempData)).then(() => {
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '更新成功',
            type: 'success',
            duration: 2000,
          })
          this.getList()
        })
      })
    },
    handleDelete(rows) {
      // 多行删除
      this.delrows(inventoryPlans, rows)
    },

    // 处理表格排序
    handleSortChange({ prop, order }) {
      if (!prop || !order) return;

      const data = this.filteredList || this.list;
      const sortedData = [...data];

      sortedData.sort((a, b) => {
        let valueA = a[prop];
        let valueB = b[prop];

        // 处理数字类型
        if (!isNaN(Number(valueA)) && !isNaN(Number(valueB))) {
          valueA = Number(valueA);
          valueB = Number(valueB);
        }

        // 处理日期类型
        if (valueA && valueB && !isNaN(Date.parse(valueA)) && !isNaN(Date.parse(valueB))) {
          valueA = new Date(valueA);
          valueB = new Date(valueB);
        }

        // 按照顺序排序
        if (order === 'ascending') {
          return valueA > valueB ? 1 : -1;
        } else {
          return valueA < valueB ? 1 : -1;
        }
      });

      this.list = sortedData;
    },

    // 处理表格筛选
    handleFilterChange(filteredData) {
      this.filteredList = filteredData;
      this.list = filteredData;
      this.total = filteredData.length;
    },
  },
}
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}
</style>
